import React from "react";
import { Box, Text } from "@chakra-ui/react";
import { QuantityInput } from "./QuantityInput"; 

export const ZoneRow = React.memo(({ option, quantity, onChange }) => {
  const paidSessions = quantity > 5 ? 5 : quantity;
  const optionPrice = paidSessions * option.price;

  return (
    <Box
      key={option.id}
      display="flex"
      alignItems="center"
      justifyContent="space-between"
      width="100%"
    >
      <Text width="180px">
        {option.name} (€{option.price})
      </Text>
      <Box display="flex" alignItems="center">
        <QuantityInput
          value={quantity}
          onChange={(newVal) => onChange(option.id, newVal)}
        />
        <Box width="80px" ml={4}>
          <Text fontWeight="semibold" textAlign="right">
            €{optionPrice.toFixed(2)}
          </Text>
        </Box>
      </Box>
    </Box>
  );
});
